import { render, staticRenderFns } from "./SquareYards.vue?vue&type=template&id=c84733fc&scoped=true&"
import script from "./SquareYards.vue?vue&type=script&lang=js&"
export * from "./SquareYards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84733fc",
  null
  
)

export default component.exports